import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/models';
import { MouldPerformanceData } from 'src/app/models/domain/mould-performance-data';
import { OperationalMouldDataContract } from 'src/generated-clients/moulding_process';

@Injectable({
  providedIn: 'root',
})
export class MouldPerformanceAdapter implements IAdapter<
  MouldPerformanceData,
  OperationalMouldDataContract
> {
  public adaptToDomain(item: OperationalMouldDataContract): MouldPerformanceData {
    const stuff = new MouldPerformanceData(
      item.mouldingProcessData?.cycleTime ?? 0,
      item.mouldingProcessData?.runTimeFactor ?? 0,
      item.mouldingProcessData?.numberOfElements ?? 0
    );

    return stuff;
  }
}
